module.exports = __webpack_public_path__ + "img/sc-2&3&4p-2024.6dc79eeb.jpg";